import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSocialCoachSession } from "./useSocialCoachSession";
import { PlayerSearchQuery, PlayersServices } from "../services/bedrock";

export const usePlayerSearch = () => {
  const { coachId } = useSocialCoachSession();
  const queryClient = useQueryClient();

  const searchPlayers = (params: PlayerSearchQuery) => {
    const sortedSegmentKeys = params.segmentationIds?.slice().sort() || [];
    const { data: players, isFetching } = useQuery({
      queryKey: [
        "coachPlayerList",
        coachId,
        params.searchTerm,
        params.planStatuses,
        params.planTiers,
        sortedSegmentKeys,
        params.page,
        params.sort,
        params.sortDirection,
      ],
      queryFn: async () => {
        return PlayersServices.searchPlayers(params);
      },
      placeholderData: keepPreviousData,
      staleTime: 1000 * 60 * 5, // 5 minutes
    });
    return { players, isFetching };
  };

  const clearPlayerSearchCache = () => {
    queryClient.invalidateQueries({ queryKey: ["coachPlayerList", coachId] }).catch(console.error);
  };

  return {
    searchPlayers,
    clearPlayerSearchCache,
  };
};
